/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Choose_Poster1Inputs */

const vi_guidevideo_choose_poster1 = /** @type {(inputs: Guidevideo_Choose_Poster1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ảnh bìa`)
};

/**

* @param {Guidevideo_Choose_Poster1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_choose_poster1 = /** @type {((inputs?: Guidevideo_Choose_Poster1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Choose_Poster1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_choose_poster1(inputs)
});
export { guidevideo_choose_poster1 as "guideVideo_choose_poster" }